import styled from 'styled-components';
import {
  color,
  border,
  space,
  typography,
  position,
  layout
} from 'styled-system';
import { IconType } from './index';
export const StyledIcon = styled.i<IconType>`
  ${color};
  ${space};
  ${typography};
  ${position};
  ${layout};
  ${border};

  ::before {
    ${color};
  }

  outline: none;
  vertical-align: middle;

  ${({ theme, disabled }): string =>
    disabled &&
    `
      color: ${theme.colors.disableBg} !important;
      : before {
        color: ${theme.colors.disableBg} !important;
      }
  `}
`;

StyledIcon.defaultProps = {
  fontSize: '1rem'
};
